// Vistorias (pedido 2026-10-08) — o motorista faz a vistoria do veículo
// pelo app (Perfil → Vistoria do veículo); aqui a equipe vê todas, com
// filtro por situação e busca por veículo/placa/motorista. Acesso: admin ou
// permissão vistoria.view (funcionário). Quem só tem vistoria.create
// (motorista) vê aqui apenas as próprias. O backend aplica a mesma regra.
import { createFileRoute } from "@tanstack/react-router";
import { Lock } from "lucide-react";
import { GpsInlineLoader } from "@/components/gps-loader";
import { InspectionsBrowser } from "@/components/vehicle-inspections-browser";
import { useVehicleInspectionAccess } from "@/hooks/queries/vehicle-inspections";

export const Route = createFileRoute("/vistorias")({
  component: VistoriasGate,
  head: () => ({ meta: [{ title: "Vistorias — GPS Drive" }] }),
});

function VistoriasGate() {
  const { data: access, isLoading } = useVehicleInspectionAccess();
  if (isLoading) return <GpsInlineLoader className="h-[70vh]" />;
  if (!access?.view && !access?.create) {
    return (
      <div className="flex h-screen items-center justify-center bg-background p-6">
        <div className="max-w-md text-center">
          <Lock className="mx-auto h-8 w-8 text-muted-foreground" />
          <h1 className="mt-3 text-lg font-semibold">Sem permissão</h1>
          <p className="mt-2 text-sm text-muted-foreground">
            Você não tem acesso às Vistorias. Peça a um administrador para liberar em Usuários → Editar → Permissões →
            Vistoria.
          </p>
        </div>
      </div>
    );
  }
  return <VistoriasPage canViewAll={access.view} />;
}

function VistoriasPage({ canViewAll }: { canViewAll: boolean }) {
  return (
    <div className="min-h-full bg-muted/30">
      <div className="mx-auto max-w-[1400px] space-y-5 p-4 md:p-6">
        <header>
          <h1 className="flex items-center gap-2 text-2xl font-bold tracking-tight">
            <span className="grid h-9 w-9 place-items-center rounded-xl bg-emerald-500/15 text-lg">📋</span>
            Vistorias
          </h1>
          <p className="mt-1 text-sm text-muted-foreground">
            {canViewAll
              ? "Vistorias feitas pelos motoristas no app (Perfil → Vistoria do veículo)"
              : "As vistorias que você fez pelo app"}
          </p>
        </header>
        <InspectionsBrowser canViewAll={canViewAll} />
      </div>
    </div>
  );
}
